<template>
  <!-- 支持远程搜索、向下滚动分页加载 -->
  <div>
    <el-select v-model="formParam[fieldName]" placeholder="请输入后选择" filterable remote reserve-keyword
               :multiple="multiple" clearable :disabled="disabled" :remote-method="queryList" :loading="loading"
               style="width:100%;" v-loadMore="loadMoreDataList" @clear="initList" @blur="blurMethod" @change="changeMethod">
      <el-option v-for="item in dataList" :key="item.businessId" :label="item.businessName" :value="item.businessId"/>
    </el-select>
  </div>
</template>

<script>
import {simpleListPage, simpleListPageAuth} from "@/api/crm/business";
import {mapState} from "vuex";

export default {
  name: "businessSelect",
  props: {
    formParam: {},
    paramList: {
      type: Array,
      default() {
        return []
      }
    },
    authCheck: { // 是否需要控制数据权限
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldName: {
      type: String,
      default: 'businessId'
    },
  },
  data () {
    return {
      dataList: [],
      loading: false,
      searchValue: null,
      pageNum: 1,
      pageSize: 30,
      hasNextPage: true
    };
  },
  components: {},
  mounted () {
    this.pageNum = 1
    if (this.paramList && this.paramList.length > 0) {
      this.dataList = this.paramList
      setTimeout(() => {
        this.initList()
      }, 800);
    } else {
      this.initList()
    }
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId,
    })
  },
  watch: {},
  methods: {
    queryList (searchValue) {
      this.searchValue = searchValue
      if (searchValue) {
        setTimeout(() => {
          this.loading = true;
          this.query({pageNum: 1, pageSize: this.pageSize, searchValue: searchValue})
        }, 400);
      } else {
        // 这个地方置空是为了减少由于滚动条太长，导致一下子加载很多页的情况
        this.dataList = []
        this.query({pageNum: 1, pageSize: this.pageSize})
      }
    },
    initList () {
      this.searchValue = null
      this.dataList = []
      this.query({pageNum: 1, pageSize: this.pageSize})
    },
    query (param) {
      if (this.authCheck) {
        simpleListPageAuth(param).then(response => {
          this.dataList = response.data.list
          this.hasNextPage = response.data.hasNextPage
          this.pageNum = response.data.nextPage
        }).finally(() => {
          this.loading = false;
        });
      } else {
        simpleListPage(param).then(response => {
          this.dataList = response.data.list
          this.hasNextPage = response.data.hasNextPage
          this.pageNum = response.data.nextPage
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    loadMoreDataList () {
      if (!this.hasNextPage) {
        return
      }
      let param = {pageNum: this.pageNum, pageSize: this.pageSize, searchValue: this.searchValue}
      if (this.authCheck) {
        simpleListPageAuth(param).then(response => {
          let resList = response.data.list
          if (resList && resList.length > 0) {
            this.dataList = this.dataList.concat(resList)
          }
          this.hasNextPage = response.data.hasNextPage
          this.pageNum = response.data.nextPage
        })
      } else {
        simpleListPage(param).then(response => {
          let resList = response.data.list
          if (resList && resList.length > 0) {
            this.dataList = this.dataList.concat(resList)
          }
          this.hasNextPage = response.data.hasNextPage
          this.pageNum = response.data.nextPage
        })
      }
    },
    changeMethod (data) {
      this.$emit('change', data)
    },
    blurMethod (event) {
      this.initList()
    }
  }
};
</script>
